import Banner from "./Banner"
import "./featured7525.css"

const Featuredx2 = ({ data: { banner, categoria } }) => (
  <div className="container mb-8 md:mb-12">
    <h3 className="feauteredSevenTwenty-title text-gray-600 mb-3">
      {categoria.descripcion}
    </h3>
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-5">
      {banner
        .sort((a, b) => a.orden - b.orden)
        .map((item) => (
          <Banner key={item.id} data={item} />
        ))}
    </div>
  </div>
)

export default Featuredx2
